exports.baseURL = "https://api.mxchichat.mimeld.com/";
exports.key = "5bce5aae0afdfe3ccea2a565171a901a4d451296e8c89da4";
exports.projectName = "MXChiChat Host";
